import { configureStore } from "@reduxjs/toolkit";
// import logger from "redux-logger";

// import cakeReducer from "../features/cake/cakeSlice";
// import icecreamReducer from "../features/icecream/icecreamSlice";
// import userReducer from "../features/user/userSlice";
import settingReducer from "../features/setting/settingSlice";
import filterReducer from "../features/filter/filterSlice";
import portfolioReducer from "../features/portfolio/portfolioSlice";

const store = configureStore({
  reducer: {
    // cake: cakeReducer,
    // icecream: icecreamReducer,
    // user: userReducer,
    settings: settingReducer,
    filter: filterReducer,
    portolio: portfolioReducer,
  },
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
});

export default store;
